interface VideoAudioPreviewProps {
  settings: any;
}

export const VideoAudioPreview = ({ settings }: VideoAudioPreviewProps) => {
  const isVideo = settings.mediaType === "video" || !settings.mediaType;
  const url = isVideo ? settings.videoUrl : settings.audioUrl;

  // Extract YouTube or Vimeo embed URL
  const getEmbedUrl = (url: string) => {
    if (!url) return null;
    
    // YouTube
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      const videoId = url.includes('youtu.be') 
        ? url.split('youtu.be/')[1]?.split('?')[0]
        : url.split('v=')[1]?.split('&')[0];
      return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
    }
    
    // Vimeo
    if (url.includes('vimeo.com')) {
      const videoId = url.split('vimeo.com/')[1]?.split('?')[0];
      return videoId ? `https://player.vimeo.com/video/${videoId}` : null;
    }
    
    return url;
  };

  const embedUrl = getEmbedUrl(url);
  const isEmbed = embedUrl && (url?.includes('youtube') || url?.includes('vimeo'));

  return (
    <div 
      className="w-full flex flex-col items-center justify-center py-8 px-4"
      style={{
        maxWidth: `${settings.maxWidth || 800}px`,
        margin: '0 auto',
      }}
    >
      {settings.title && (
        <h3 className="text-2xl font-bold mb-4 text-center">{settings.title}</h3>
      )}
      
      {!url ? (
        <div className="w-full bg-muted rounded-lg p-12 text-center">
          <p className="text-muted-foreground">
            {isVideo ? '🎥 لم يتم رفع أو إضافة رابط فيديو بعد' : '🎵 لم يتم رفع أو إضافة رابط صوت بعد'}
          </p>
        </div>
      ) : isVideo ? (
        isEmbed ? (
          <div 
            className="w-full relative overflow-hidden"
            style={{
              aspectRatio: settings.aspectRatio || '16/9',
              borderRadius: `${settings.borderRadius || 12}px`,
            }}
          >
            <iframe
              src={`${embedUrl}${settings.autoplay ? '?autoplay=1&mute=1' : ''}`}
              className="absolute inset-0 w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        ) : (
          <video
            src={embedUrl || ''}
            controls={settings.showControls ?? true}
            autoPlay={settings.autoplay ?? false}
            muted={settings.muted ?? true}
            loop={settings.loop ?? false}
            className="w-full"
            style={{
              aspectRatio: settings.aspectRatio || '16/9',
              borderRadius: `${settings.borderRadius || 12}px`,
              objectFit: 'cover',
            }}
          />
        )
      ) : (
        <audio
          src={embedUrl || ''}
          controls={settings.showControls ?? true}
          autoPlay={settings.autoplay ?? false}
          muted={settings.muted ?? true}
          loop={settings.loop ?? false}
          className="w-full"
          style={{
            borderRadius: `${settings.borderRadius || 12}px`,
          }}
        />
      )}
    </div>
  );
};
